/* WallboxWelt – technische Daten aus älteren Rich-Text-Metafeldern automatisch strukturieren */
(() => {
  const getLines = (element) => {
    /* textContent funktioniert auch dann zuverlässig, wenn der technische Tab noch hidden ist.
       <br>-Elemente werden zusätzlich explizit in Zeilenumbrüche umgewandelt. */
    const clone = element.cloneNode(true);
    clone.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));

    const text = clone.textContent || element.textContent || element.innerText || '';

    return text
      .replace(/\r/g, '')
      .split(/\n+/)
      .map((line) => line.trim())
      .filter(Boolean);
  };

  const parseTechnicalLine = (line) => {
    const colonIndex = line.indexOf(':');
    if (colonIndex <= 0) return null;

    const label = line.slice(0, colonIndex + 1).trim();
    const value = line.slice(colonIndex + 1).trim();
    if (!label || !value) return null;

    return { label, value };
  };

  const convertPlainTechnicalData = (root = document) => {
    root
      .querySelectorAll('[data-ww-product-tabs] [data-ww-panel="technical"] .metafield-rich_text_field')
      .forEach((richText) => {
        /* Ältere Listings enthalten mehrere "Merkmal: Wert"-Zeilen in einem einzigen Absatz.
           Diese Absätze werden in dieselbe zweispaltige Struktur wie die neueren Listings umgebaut. */
        Array.from(richText.children).forEach((element) => {
          if (element.tagName !== 'P' || element.dataset.wwAutoTechReady === 'true') return;

          const lines = getLines(element);
          if (lines.length < 2) return;

          const parsedLines = lines.map(parseTechnicalLine).filter(Boolean);
          const requiredMatches = Math.max(2, Math.ceil(lines.length * 0.7));
          if (parsedLines.length < requiredMatches) return;

          const list = document.createElement('ul');
          list.className = 'ww-tech-auto-list';
          list.dataset.wwAutoTechReady = 'true';

          parsedLines.forEach(({ label: labelText, value: valueText }) => {
            const item = document.createElement('li');
            item.className = 'ww-tech-row';
            item.dataset.wwTechRowReady = 'true';

            const label = document.createElement('span');
            label.className = 'ww-tech-label';
            const strong = document.createElement('strong');
            strong.textContent = labelText;
            label.appendChild(strong);

            const value = document.createElement('span');
            value.className = 'ww-tech-value';
            value.textContent = valueText;

            item.append(label, value);
            list.appendChild(item);
          });

          if (list.children.length >= 2) element.replaceWith(list);
        });

        /* Ein kurzer Absatz unmittelbar vor einer Spezifikationsliste ist eine Gruppenüberschrift. */
        Array.from(richText.children).forEach((element) => {
          if (element.tagName !== 'P') return;

          const text = (element.textContent || '').trim();
          const next = element.nextElementSibling;
          const nextIsSpecification =
            next &&
            (next.classList.contains('ww-tech-auto-list') || next.matches('ul, ol, table'));

          if (!nextIsSpecification || !text || text.includes(':') || text.length > 100) return;

          const heading = document.createElement('h3');
          heading.className = 'ww-tech-auto-heading';
          heading.textContent = text;
          element.replaceWith(heading);
        });
      });
  };

  const init = (root = document) => convertPlainTechnicalData(root);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target || document));

  /* Failsafe: Beim Öffnen des Tabs erneut prüfen. Bereits konvertierte Inhalte bleiben unverändert. */
  document.addEventListener('click', (event) => {
    const technicalTab = event.target.closest('[data-ww-tab="technical"]');
    if (!technicalTab) return;

    const tabsRoot = technicalTab.closest('[data-ww-product-tabs]') || document;
    requestAnimationFrame(() => init(tabsRoot));
  });
})();

/* WallboxWelt – Feinschliff für Zusatzprodukte, Tabs und mobile Sticky-CTA */
(() => {
  const polishComplementaryInput = (input) => {
    if (!input || !input.matches('.ww-inline-complementary__checkbox')) return;

    const row = input.closest('.ww-inline-complementary__item');
    const content = row?.querySelector('.ww-inline-complementary__content');
    const wasAdded = input.dataset.added === 'true';

    if (!wasAdded) {
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Zusatzprodukt hinzufügen');
      return;
    }

    input.checked = true;
    input.disabled = true;
    input.setAttribute('aria-label', 'Zusatzprodukt wurde hinzugefügt');
    row?.classList.add('is-added');

    if (content && !content.querySelector('.ww-inline-complementary__added-label')) {
      const addedLabel = document.createElement('span');
      addedLabel.className = 'ww-inline-complementary__added-label';
      addedLabel.textContent = 'Hinzugefügt ✓';
      content.appendChild(addedLabel);
    }
  };

  const scanComplementaryInputs = (root = document) => {
    if (root.matches?.('.ww-inline-complementary__checkbox')) polishComplementaryInput(root);
    root.querySelectorAll?.('.ww-inline-complementary__checkbox').forEach(polishComplementaryInput);
  };

  const initComplementaryPolish = () => {
    scanComplementaryInputs(document);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') polishComplementaryInput(record.target);
      });
    });

    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-added'],
    });
  };

  /* Home/End vervollständigen die Tastatursteuerung der Produkt-Tabs. */
  const initTabKeyboardPolish = () => {
    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Home' && event.key !== 'End') return;
        const current = event.target.closest?.('[data-ww-tab]');
        if (!current) return;

        const tabsRoot = current.closest('[data-ww-product-tabs]');
        const tabs = Array.from(tabsRoot?.querySelectorAll('[data-ww-tab]') || []);
        if (!tabs.length) return;

        event.preventDefault();
        const target = event.key === 'Home' ? tabs[0] : tabs[tabs.length - 1];
        target.focus();
        target.click();
      },
      true
    );
  };

  /* Die mobile Sticky-CTA verschwindet spätestens nach dem Produktbereich wieder. */
  const initStickyBoundary = () => {
    const update = () => {
      const sticky = document.querySelector('[data-ww-mobile-sticky-atc]');
      const section = document.querySelector('section[id^="MainProduct-"]');
      if (!sticky || !section) return;

      if (section.getBoundingClientRect().bottom <= 0) sticky.classList.remove('is-visible');
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const start = () => {
    initComplementaryPolish();
    initTabKeyboardPolish();
    initStickyBoundary();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scanComplementaryInputs(event.target || document);
  });
})();
